import React from 'react';
import './TokenScreens.css';

const ERROR_ICONS = {
  'invalid-token': (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  'no-token': (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  'network': (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="1" y1="1" x2="23" y2="23" />
      <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
      <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
      <path d="M10.71 5.05A16 16 0 0 1 22.56 9" />
      <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
      <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
      <line x1="12" y1="20" x2="12.01" y2="20" />
    </svg>
  ),
  'unauthorized': (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  'server': (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
};

/**
 * Full-screen error state for invalid tokens, network errors, etc.
 * Provides clear guidance on what went wrong and next steps.
 */
export default function TokenErrorScreen({ error, onRetry }) {
  const errorType = error?.type || 'server';
  const errorMessage = error?.message || 'Something went wrong. Please try again.';
  const icon = ERROR_ICONS[errorType] || ERROR_ICONS['server'];
  const canRetry = errorType === 'network' || errorType === 'server';

  return (
    <div className="token-screen token-screen--error" data-testid="error-screen" role="alert">
      <div className="token-screen__content">
        <div className="token-screen__logo" aria-hidden="true">
          <span className="token-screen__logo-icon">D</span>
        </div>

        <div className="token-screen__error-icon" aria-hidden="true" data-testid={`error-icon-${errorType}`}>
          {icon}
        </div>

        <h1 className="token-screen__title">
          {errorType === 'no-token' && 'Link Required'}
          {errorType === 'invalid-token' && 'Invalid Link'}
          {errorType === 'network' && 'Connection Problem'}
          {errorType === 'unauthorized' && 'Access Denied'}
          {errorType === 'server' && 'Something Went Wrong'}
        </h1>

        <p className="token-screen__message" data-testid="error-message">
          {errorMessage}
        </p>

        {canRetry && onRetry && (
          <button
            className="btn btn--primary token-screen__retry-btn"
            onClick={onRetry}
            data-testid="retry-btn"
          >
            Try Again
          </button>
        )}

        <div className="token-screen__help">
          <p>Need help? Contact us:</p>
          <a href="tel:0115682963" className="token-screen__help-link">
            011 568 2963
          </a>
          <a href="mailto:customercare@dola.co.za" className="token-screen__help-link">
            customercare@dola.co.za
          </a>
        </div>
      </div>
    </div>
  );
}
